import {pagination} from "./state"
const mutations = {
    setListSnapConsole: (state, res) => {
        if (state.listSnapConsole.data !== undefined) {
            state.listSnapConsole.data = [...state.listSnapConsole.data, ...res.data];
        } else {
            state.listSnapConsole = res
        }
    },
    resetListSnapConsole: (state) => {
        state.listSnapConsole = []
    },

    setNextPagination: (state, payload) => {
        state.pagination.length = payload.data.length
        state.pagination.pageNumber++
        state.pagination.offset = state.pagination.pageNumber * state.pagination.limit
    },
    resetPagination: state => state.pagination = pagination()
}

export default mutations